import { AppBar as MuiAppBar } from "@material-ui/core";
import styled from "styled-components";

export const StyledAppBar = styled(MuiAppBar)`
  && {
    background-color: ${({ theme }) => theme.colors.primary};
    align-items: center;
  }
`;
